import { combineSlices } from '@reduxjs/toolkit';
import { deliveredOrdersSlice } from './deliveredOrders/redux';
import { deliveredOrdersSearchSlice } from './deliveredOrdersSearch/redux';

export const deliveredOrdersReducer = combineSlices(
  deliveredOrdersSearchSlice,
  deliveredOrdersSlice,
);
